import React from "react";
import KFormField from "./kFormField";

import SubjectDropDown from "./subjectDropDown";
import { Grid } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Box from "@material-ui/core/Box";

class Students extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      students: props.students, //getStore().terms
    };

    // readOnly is only for subjeccts.. 1/25/2021
    this.readOnly = true; //this.props.readOnly; // only for subjects. names can still be edited.
  }

  updateStudents(index, property, value) {
    // console.log(`Updating Student ${index}'s ${property} to ${value}`);
    let updatedStudent = {};
    this.setState(
      (state) => {
        const students = state.students.map((item, j) => {
          if (j === index) {
            item[property] = value;
            updatedStudent = item;
            return item;
          } else {
            return item;
          }
        });
        return {
          students,
        };
      },
      () => this.onStudentUpdated(index, updatedStudent)
    );
  }

  // called after setState callback
  onStudentUpdated = (index, updatedStudent) => {
    return this.props.onChange(index, updatedStudent);
  };

  /*
    onStartDateChanged = (id, value) => {
      this.updateStudents(parseInt(id.split('.')[1]), id.split('.')[2], value);
    }*/

  onSubjectChanged = (id, value) => {
    this.updateStudents(parseInt(id.split(".")[1]), id.split(".")[2], value);
  };

  onNameChange = (id, value) => {
    this.updateStudents(parseInt(id.split(".")[1]), id.split(".")[2], value);
  };

  getStudentSuffix(index) {
    if (this.state.students.length === 1) {
      return "";
    } else return index + 1;
  }

  render() {
    let t = this;
    return (
      <div>
        {this.state.students.map((s, index) => (
          <div key={`student.${index}.subjects`}>
            <Box  pb={2}>
            <Grid container spacing={3} key={index.toString()}>
              <Grid item xs={12} sm={6}>
                <KFormField
                  id={`student.${index}.name`}
                  layout="horizontal"
                  label={`Student ${this.getStudentSuffix(index)} Name`}
                  onChange={t.onNameChange}
                  validator={t.props.validator}
                  value={s.name}
                  fullWidth
                  placeholder="Student Name"
                ></KFormField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <SubjectDropDown
                  id={`student.${index}.subjects`}
                  key={`student.${index}.subjects`}
                  value={s.subjects}
                  readOnly={t.readOnly}
                  onChange={this.onSubjectChanged}
                />
              </Grid>
            </Grid>

            { (this.state.students.length !== index+1) &&
              <Box pt={2}>
                <Divider />
              </Box>
            }
            
            </Box>
          </div>
        ))}
      </div>
    );
  }
}
export default Students;

/*
<Grid item xs={12} sm={4}>
<StudentPromotions items={s.promoTexts}></StudentPromotions>
</Grid>


function StudentPromotions(props) {
  return (
    <Box ml={2} mr={2}>


<TableContainer component={Paper}>
          <Table size="small">
            <TableBody>
            {props.items.map((c,index) => 
                <TableRow key={index}>
                  <TableCell dangerouslySetInnerHTML={{ __html: c }}></TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>



     
    </Box>
  );
}*/
